/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const caravan_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.25 19.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.5c.817 0 1.5-.683 1.5-1.5v-3m-6 4.5h-3m-7.5 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h7.5m-10.5 0h-1.5c-.817 0-1.5-.683-1.5-1.5v-6m22.5 3c0-.488-.152-.963-.436-1.36L19.5 9m3.75 6h-9m0-3V9h5.25m-5.25 3H.75m13.5 0v3M.75 12V6c0-1.634 1.366-3 3-3h16.5c1.634 0 3 1.366 3 3s-1.366 3-3 3h-.75m-5.25 10.5V15"
    />
  </svg>
)
export default caravan_medium
